import { Box, Tooltip, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import ErrorIcon from '@mui/icons-material/Error'
import WarningIcon from '@mui/icons-material/Warning'

interface Props {
  data: {
    errors: number
    warnings: number,
    path: string,
    isPending: boolean,
    isSitemapsIndex: boolean,
    contents: Array<{
      indexed: number
      submitted: number
      type: string
    }>
  }
}

const SitemapPath = ({ data }: Props) => {
  const { t } = useTranslation()

  let toolTip = t('sitemapStatusOk')
  let icon = <CheckCircleIcon sx={{ color: 'green', mr: 1 }} />;

  if(data.errors) {
    toolTip = t('sitemapStatusError')
    icon = <ErrorIcon sx={{ color: 'red', mr: 1 }} />
  } else if(data.warnings) {
    toolTip = t('sitemapStatusWarning')
    icon = <WarningIcon sx={{ color: 'orange', mr: 1 }} />
  }

  return (
    <Box display="flex" alignItems="center">
      <Tooltip title={toolTip} arrow followCursor>
        {icon}
      </Tooltip>
      <Typography>{data.path.substring(data.path.lastIndexOf('/') + 1 )}</Typography>

      {
        data.isPending && (
          <Tooltip title={t('tooltip.sitemapPending')} arrow followCursor >
            <Typography sx={{ ml: 1 }}>🕐</Typography>
          </Tooltip>
        )
      }

      {
        data.isSitemapsIndex && (
          <Tooltip title={t('tooltip.sitemapIndex')} arrow followCursor >
            <Typography sx={{ ml: 1 }}>📂</Typography>
          </Tooltip>
        )
      }

    </Box>
  )
}

export default SitemapPath;